var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterXLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49233 12.31L2 3H7.93446L12.5594 8.75425L17.5004 3.02591H20.7688L14.1397 10.7204L22 20.5H16.0833L11.0754 14.2771L5.72896 20.4827H2.44287L9.49233 12.31ZM16.9457 18.775L5.63881 4.72499H7.07138L18.364 18.775H16.9457Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXLight);
export default __webpack_public_path__ + "static/media/twitter-x-light.6fb656a0aaa4634bc4f7e765a9a28014.svg";
export { ForwardRef as ReactComponent };